import { useState, useEffect, useCallback } from "react";
import styles from "./AdminTickets.module.css";
import { adminListTickets } from "../../../../lib/store";

const PER_PAGE = 10;

export default function AdminTickets() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);

  const load = useCallback(() => {
    setLoading(true);
    setError("");
    adminListTickets()
      .then(setTickets)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const filtered = tickets.filter((t) => {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    return [t.name, t.email, t.phone, t.city, t.preferredDate].some((v) =>
      (v || "").toLowerCase().includes(q),
    );
  });

  useEffect(() => {
    setPage(1);
  }, [query]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PER_PAGE));
  const currentPage = Math.min(page, totalPages);
  const pageTickets = filtered.slice(
    (currentPage - 1) * PER_PAGE,
    currentPage * PER_PAGE,
  );

  return (
    <div className={styles.wrap}>
      <div className={styles.headerRow}>
        <div>
          <div className={styles.pageTitle}>Tickets</div>
          <div className={styles.subtle}>
            {tickets.length} rep visit request{tickets.length === 1 ? "" : "s"}
          </div>
        </div>
      </div>

      <input
        className={styles.search}
        placeholder="Search tickets..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {loading ? (
        <div className={styles.spinnerWrap}>
          <span className={styles.spinner} />
          <span>Loading tickets…</span>
        </div>
      ) : error ? (
        <div className={styles.error}>{error}</div>
      ) : filtered.length === 0 ? (
        <div className={styles.empty}>No tickets found.</div>
      ) : (
        <>
          <div className={styles.tableWrap}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.idxCol}>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Preferred Date</th>
                  <th>Preferred Time</th>
                  <th>City</th>
                </tr>
              </thead>
              <tbody>
                {pageTickets.map((t, i) => (
                  <tr key={t.id}>
                    <td className={styles.idxCol}>{(currentPage - 1) * PER_PAGE + i + 1}</td>
                    <td className={styles.fileName}>{t.name || "—"}</td>
                    <td>{t.email || "—"}</td>
                    <td>{t.phone || "—"}</td>
                    <td>{t.preferredDate || "—"}</td>
                    <td>{t.preferredTime || "—"}</td>
                    <td>{t.city || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className={styles.pagination}>
              <button
                className={styles.pageBtn}
                disabled={currentPage <= 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
              >
                ← Prev
              </button>
              <span className={styles.pageInfo}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className={styles.pageBtn}
                disabled={currentPage >= totalPages}
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              >
                Next →
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
